/*** escape string for regex
 *** ex: "italya turu (mi" -> "italya turu \\(mi"
 ** @param keyword string
 ** @returns string
 */
const escapeRegex = (keyword: string) => {
  return keyword.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&');
};
export default escapeRegex;
